import {Outlet} from '@github-ui/react-router'
import {PageLayout} from '@primer/react'
import type {CSSProperties, ReactElement} from 'react'

const contentStyle: CSSProperties = {maxWidth: '1400px'}

interface SharedLayoutProps {
  header: ReactElement
  sidebar: ReactElement
}

export function SharedLayout({sidebar, header}: SharedLayoutProps) {
  return (
    <PageLayout containerWidth="full" columnGap="none" padding="none">
      <PageLayout.Pane
        divider="line"
        hidden={{narrow: true, regular: false, wide: false}}
        padding="condensed"
        position="start"
        className="min-height-full"
      >
        <aside>{sidebar}</aside>
      </PageLayout.Pane>

      <PageLayout.Content as="div" padding="condensed" className="px-2 mx-auto" style={contentStyle}>
        {header}
        <Outlet />
      </PageLayout.Content>
    </PageLayout>
  )
}
